import { useRef, useState } from "react";
import { Play, Pause } from "lucide-react";
import { ASSETS } from "@/lib/assets";

export const SpeakVideo = ({ poster, testIdSuffix = "" }) => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const toggle = () => {
    const v = videoRef.current;
    if (!v) return;
    if (v.paused) {
      v.play();
      setPlaying(true);
    } else {
      v.pause();
      setPlaying(false);
    }
  };

  return (
    <div
      data-testid={`speak-video${testIdSuffix ? `-${testIdSuffix}` : ""}`}
      className="relative w-full aspect-video bg-black overflow-hidden border border-white/10 group"
    >
      <video
        ref={videoRef}
        poster={poster}
        playsInline
        preload="metadata"
        controls={playing}
        onEnded={() => setPlaying(false)}
        className="w-full h-full object-cover"
      >
        {/* MP4 must be listed first — iOS Safari picks the first source it
            claims to support and does not fall back after a decode failure. */}
        <source src={ASSETS.videos.speakFarum} type="video/mp4" />
        <source src="/media/speak-farum.webm" type="video/webm" />
      </video>
      {!playing && (
        <button
          onClick={toggle}
          aria-label="Afspil video"
          data-testid="speak-video-play-btn"
          className="absolute inset-0 flex items-center justify-center bg-black/30 hover:bg-black/40 transition-colors"
        >
          <span className="flex items-center justify-center w-20 h-20 md:w-28 md:h-28 rounded-full border border-[color:var(--fk-gold)] text-[color:var(--fk-gold)] group-hover:bg-[color:var(--fk-gold)] group-hover:text-black transition-all duration-500">
            <Play className="w-8 h-8 md:w-10 md:h-10 ml-1" />
          </span>
        </button>
      )}
      {playing && (
        <button
          onClick={toggle}
          aria-label="Pause"
          className="absolute top-4 right-4 p-2 bg-black/60 backdrop-blur text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
        >
          <Pause className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};
